import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { SavedSearchNS } from '../../models/saved-search.models';
import { LocalDatePipe } from 'src/app/modules/shared/pipes/local-date.pipe';

@Component({
    selector: 'app-saved-search-preview-modal',
    templateUrl: './saved-search-preview-modal.component.html',
    styleUrls: ['./saved-search-preview-modal.component.scss'],
    providers: [LocalDatePipe]
})
export class SavedSearchPreviewModalComponent implements OnInit, OnDestroy, OnChanges {
    @Input() displayPreviewDataList: boolean = false;
    @Input() previewDataList: [];
    @Input() previewColumnList: SavedSearchNS.ISavedSearchPreviceColumnModel[];
    @Output() onPreviewCancel = new EventEmitter<any>();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    noData: string = "No data available for preview."
    constructor() { }

    ngOnInit(): void {
        console.log();
    }
    ngOnChanges(changes: SimpleChanges): void {
        setTimeout(() => {
        }, 0);
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    onPreviewCancelClick(): void {
        this.displayPreviewDataList = false;
        this.onPreviewCancel.emit();
    }
}
